import React from 'react';

import fr from 'react-intl/locale-data/fr';
import es from 'react-intl/locale-data/es';
import {IntlProvider, addLocaleData} from 'react-intl';

class CustomIntlWrapper extends React.Component {

  constructor(props) {
    super(props);

    addLocaleData([...fr]);
    addLocaleData([...es]);

    this.state = { };
  }

  render() {
    return <IntlProvider locale={this.props.data.locale} messages={this.props.data.messages} {...this.props}>
      {this.props.children}
    </IntlProvider>;
  }
}

export default CustomIntlWrapper;
